import React, { useState, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import api from '~/services/api';
import history from '~/services/history';
// Importando componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Select from '~/components/Form/Select';
import Load from '~/components/Load';

import { Container } from './styles';

export default function TimesEdit({ match }) {
  const user = useSelector(state => state.user.profile);
  const inputRef = useRef(null);
  const [cidade, setCidade] = useState([]);
  const [dado, setDado] = useState([]);
  const [cidadeId, setCidadeId] = useState(0);
  const [sabado, setSabado] = useState(0);
  const [domingo, setDomingo] = useState(0);
  const [incorporadoras, setIncorporadoras] = useState([]);
  const [incorporadoraId, setIncorporadoraId] = useState(0);
  const [modelo, setModelo] = useState([]);
  const [temperaturaId, setTemperaturaId] = useState(0);
  const [corretoresId, setCorretoresId] = useState(0);
  const [carregar, setCarregar] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getTime() {
      setLoading(true);
      const { id: ids } = match.params;
      // Dados do time
      const response = await api.get(
        `incorporadora/${user.time.incorporadora_id}/time/${ids}`
      );
      // Dados da incorporadora
      if (user.provider === '4') {
        const inc = await api.get('/incorporadora');
        const dat = inc.data.map(ic => ({
          value: ic.id,
          label: ic.name,
        }));
        setIncorporadoras(dat);

        const dataIncorporadora = dat.filter(incorporadora => {
          return incorporadora.value === response.data.incorporadora_id;
        });

        setIncorporadoraId(dataIncorporadora[0]);
      }

      // Dados da cidade
      const responseCidade = await api.get('/cidades');

      const data = responseCidade.data.map(ci => ({
        value: ci.id,
        label: ci.name,
      }));

      const dataCidade = data.filter(cid => {
        return cid.value === response.data.cidade_id;
      });

      setCidadeId(dataCidade[0]);

      setSabado({
        value: response.data.atende_sabado,
        label: response.data.atende_sabado === '1' ? 'Sim' : 'Não',
      });

      setDomingo({
        value: response.data.atende_domingo,
        label: response.data.atende_domingo === '1' ? 'Sim' : 'Não',
      });

      setModelo({
        value: response.data.modelo_atendimento,
        label:
          response.data.modelo_atendimento === '1'
            ? 'Aleatorio'
            : 'Horario de trabalho do sdr',
      });

      const temp =
        response.data.temperatura === null ? '2' : response.data.temperatura;

      setTemperaturaId({
        value: temp,
        label: temp === '1' ? 'Sim' : 'Não',
      });

      const corret =
        response.data.corretores === null ? '2' : response.data.corretores;

      setCorretoresId({
        value: corret,
        label: corret === '1' ? 'Sim' : 'Não',
      });

      setCidade(data);

      setDado(response.data);
      setLoading(false);
    }
    getTime();
  }, [match.params, user.provider, user.time.incorporadora_id]);

  const dataTemplate = [
    {
      value: 1,
      label: 'Sim',
    },
    {
      value: 2,
      label: 'Não',
    },
  ];

  const modeloTemplate = [
    {
      value: 1,
      label: 'Aleatorio',
    },
    {
      value: 2,
      label: 'Horario de trabalho do sdr',
    },
  ];

  /**
   * Funcoes
   */
  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      let schema;

      if (user.provider !== '4') {
        schema = Yup.object().shape({
          name: Yup.string().required('Preencha o campo nome'),
          cidade_id: Yup.string('Selecione uma cidade').required(
            'Selecione uma cidade'
          ),
          incorporadora_id: Yup.string('Selecione a incorporadora').required(
            'Selecione a incorporadora'
          ),
          telefone: Yup.string().required('Preencha o campo telefone'),
          email: Yup.string().email('Informe um email válido'),
          token: Yup.string().required('Preencha o campo token (Mercury)'),
          instance_number: Yup.string().required(
            'Preencha o campo instance number (Mercury)'
          ),
          hora_abertura: Yup.string().required(
            'Preencha o campo hora de abertura'
          ),
          hora_encerramento: Yup.string().required(
            'Preencha o campo hora de encerramento'
          ),
          atende_sabado: Yup.string('Selecione se atende no sabado').required(
            'Selecione se atende no sabado'
          ),
          hora_abertura_sabado: Yup.string()
            .when('atende_sabado', {
              is: '1',
              then: Yup.string().required('Preencha o campo hora de abertura aos sábados')
            }),
          hora_encerramento_sabado: Yup.string()
            .when('atende_sabado', {
              is: '1',
              then: Yup.string().required('Preencha o campo hora de encerramento aos sábados')
            }),
          atende_domingo: Yup.string('Selecione se atende no domingo').required(
            'Selecione se atende no domingo'
          ),
          hora_abertura_domingo: Yup.string()
            .when('atende_domingo', {
              is: '1',
              then: Yup.string().required('Preencha o campo hora de abertura aos domingos')
            }),
          hora_encerramento_domingo: Yup.string()
            .when('atende_domingo', {
              is: '1',
              then: Yup.string().required('Preencha o campo hora de encerramento aos domingos')
            }),
          token_voice: Yup.string().required(
            'Preencha o campo token (Total Voice)'
          ),
          id_ramal: Yup.string().required(
            'Preencha o campo id ramal (Total Voice)'
          ),
          ramal: Yup.string().required('Preencha o campo ramal (Total Voice)'),
          numero_atendimento: Yup.string().required(
            'Preencha o campo numero de atendimento'
          ),
          modelo_atendimento: Yup.string(
            'Selecione o modelo de atendimento'
          ).required('Selecione o modelo de atendimento'),
          temperatura: Yup.string(
            'Selecione se irá trabalhar com sistema de temperatura'
          ).required('Selecione se irá trabalhar com sistema de temperatura'),
          corretores: Yup.string(
            'Selecione se irá trabalhar com sistema de corretores'
          ).required('Selecione se irá trabalhar com sistema de corretores'),
        });
      } else {
        schema = Yup.object().shape({
          name: Yup.string().required('Preencha o campo nome'),
          cidade_id: Yup.string('Selecione uma cidade').required(
            'Selecione uma cidade'
          ),
          telefone: Yup.string()
            .required('Preencha o campo telefone')
            .min(10, 'Minimo de 10 numeros')
            .max(11, 'Maximo de 11 numeros'),
          email: Yup.string().email('Informe um email válido'),
          token: Yup.string().required('Preencha o campo token (Mercury)'),
          instance_number: Yup.string().required(
            'Preencha o campo instance number (Mercury)'
          ),
          hora_abertura: Yup.string().required(
            'Preencha o campo hora de abertura'
          ),
          hora_encerramento: Yup.string().required(
            'Preencha o campo hora de encerramento'
          ),
          atende_sabado: Yup.string('Selecione se atende no sabado').required(
            'Selecione se atende no sabado'
          ),
          hora_abertura_sabado: Yup.string()
            .when('atende_sabado', {
              is: '1',
              then: Yup.string().required('Preencha o campo hora de abertura aos sábados')
            }),
          hora_encerramento_sabado: Yup.string()
            .when('atende_sabado', {
              is: '1',
              then: Yup.string().required('Preencha o campo hora de encerramento aos sábados')
            }),
          atende_domingo: Yup.string('Selecione se atende no domingo').required(
            'Selecione se atende no domingo'
          ),
          hora_abertura_domingo: Yup.string()
            .when('atende_domingo', {
              is: '1',
              then: Yup.string().required('Preencha o campo hora de abertura aos domingos')
            }),
          hora_encerramento_domingo: Yup.string()
            .when('atende_domingo', {
              is: '1',
              then: Yup.string().required('Preencha o campo hora de encerramento aos domingos')
            }),
          token_voice: Yup.string().required(
            'Preencha o campo token (Total Voice)'
          ),
          id_ramal: Yup.string().required(
            'Preencha o campo id ramal (Total Voice)'
          ),
          ramal: Yup.string().required('Preencha o campo ramal (Total Voice)'),
          numero_atendimento: Yup.string().required(
            'Preencha o campo numero de atendimento'
          ),
          modelo_atendimento: Yup.string(
            'Selecione o modelo de atendimento'
          ).required('Selecione o modelo de atendimento'),
          temperatura: Yup.string(
            'Selecione se irá trabalhar com sistema de temperatura'
          ).required('Selecione se irá trabalhar com sistema de temperatura'),
          corretores: Yup.string(
            'Selecione se irá trabalhar com sistema de corretores'
          ).required('Selecione se irá trabalhar com sistema de corretores'),
        });
      }
      await schema.validate(data, {
        abortEarly: false,
      });

      if (user.provider === '4') {
        const incorporadora =
          data.incorporadora_id === undefined
            ? incorporadoraId.value
            : data.incorporadora_id;

        await api.put(`/incorporadora/${incorporadora}/time/${dado.id}`, {
          cidade_id:
            data.cidade_id === undefined ? cidadeId.value : data.cidade_id,
          atende_sabado:
            data.atende_sabado === undefined
              ? sabado.value
              : data.atende_sabado,
          atende_domingo:
            data.atende_domingo === undefined
              ? domingo.value
              : data.atende_domingo,
          modelo_atendimento:
            data.modelo_atendimento === undefined
              ? modelo.value
              : data.modelo_atendimento,
          temperatura:
            data.temperatura === undefined
              ? temperaturaId.value
              : data.temperatura,
          corretores:
            data.corretores === undefined
              ? corretoresId.value
              : data.corretores,
          name: data.name,
          telefone: data.telefone,
          email: data.email,
          token: data.token,
          instance_number: data.instance_number,
          hora_abertura: data.hora_abertura,
          hora_encerramento: data.hora_encerramento,
          hora_abertura_sabado: data.hora_abertura_sabado,
          hora_encerramento_sabado: data.hora_encerramento_sabado,
          hora_abertura_domingo: data.hora_abertura_domingo,
          hora_encerramento_domingo: data.hora_encerramento_domingo,
          token_voice: data.token_voice,
          id_ramal: data.id_ramal,
          ramal: data.ramal,
          numero_atendimento: data.numero_atendimento,
        });
      } else {
        await api.put(
          `/incorporadora/${user.time.incorporadora_id}/time/${dado.id}`,
          {
            cidade_id:
              data.cidade_id === undefined ? cidadeId.value : data.cidade_id,
            atende_sabado:
              data.atende_sabado === undefined
                ? sabado.value
                : data.atende_sabado,
            atende_domingo:
              data.atende_domingo === undefined
                ? domingo.value
                : data.atende_domingo,
            modelo_atendimento:
              data.modelo_atendimento === undefined
                ? modelo.value
                : data.modelo_atendimento,
            temperatura:
              data.temperatura === undefined
                ? temperaturaId.value
                : data.temperatura,
            corretores:
              data.corretores === undefined
                ? corretoresId.value
                : data.corretores,
            name: data.name,
            telefone: data.telefone,
            email: data.email,
            token: data.token,
            instance_number: data.instance_number,
            hora_abertura: data.hora_abertura,
            hora_encerramento: data.hora_encerramento,
            hora_abertura_sabado: data.hora_abertura_sabado,
            hora_encerramento_sabado: data.hora_encerramento_sabado,
            hora_abertura_domingo: data.hora_abertura_domingo,
            hora_encerramento_domingo: data.hora_encerramento_domingo,
            token_voice: data.token_voice,
            id_ramal: data.id_ramal,
            ramal: data.ramal,
            numero_atendimento: data.numero_atendimento,
          }
        );
      }

      toast.success('Time editado com sucesso');
      history.push('/times');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
          console.log(validationErrors)
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao cadastrar o temperatura verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Editar Time</h4>
      <Card>
        <Form
          ref={inputRef}
          onSubmit={handlerSubmit}
          autoComplete="off"
          initialData={dado}
        >
          <Input icon="MdBusiness" label="Nome" name="name" type="text" />
          {user.provider === '4' && (
            <Select
              name="incorporadora_id"
              labelSelect="Incorporadora"
              options={incorporadoras}
              onChange={e => setIncorporadoraId(e)}
              defaultValue={incorporadoraId}
            />
          )}
          <Select
            name="cidade_id"
            labelSelect="Cidade"
            options={cidade}
            onChange={e => setCidadeId(e)}
            defaultValue={cidadeId}
          />
          <Input
            icon="MdPhone"
            label="Telefone"
            name="telefone"
            type="number"
          />
          <Input
            icon="MdPhone"
            label="Numero de atendimento"
            name="numero_atendimento"
            type="text"
          />
          <Input
            icon="MdEmail"
            label="Email"
            name="email"
            type="text"
          />
          <Input
            icon="MdChat"
            label="Token (ZapBox)"
            name="token"
            type="text"
          />
          <Input
            icon="MdChat"
            label="Url de atendimento (ZapBox)"
            name="instance_number"
            type="text"
          />
          <Input
            icon="MdHeadset"
            label="Token (Total Voice)"
            name="token_voice"
            type="text"
          />
          <Input
            icon="MdHeadset"
            label="Id ramal (Total Voice)"
            name="id_ramal"
            type="text"
          />
          <Input
            icon="MdKeyboardVoice"
            label="Ramal (Total Voice)"
            name="ramal"
            type="text"
          />
          <Input
            icon="MdTimer"
            label="Hora de abertura"
            name="hora_abertura"
            type="time"
          />
          <Input
            icon="MdTimer"
            label="Hora de encerramento"
            name="hora_encerramento"
            type="time"
          />
          <Select
            name="atende_sabado"
            labelSelect="Atende no sabado"
            options={dataTemplate}
            onChange={e => setSabado(e)}
            defaultValue={sabado}
          />
          {
            sabado.value == 1 ?
              <>
                <Input
                  icon="MdTimer"
                  label="Hora de abertura aos sabados"
                  name="hora_abertura_sabado"
                  type="time"
                /> 
                <Input
                  icon="MdTimer"
                  label="Hora de encerramento aos sabados"
                  name="hora_encerramento_sabado"
                  type="time"
                />
              </> : <></>
          }
          <Select
            name="atende_domingo"
            labelSelect="Atende no domingo"
            options={dataTemplate}
            onChange={e => setDomingo(e)}
            defaultValue={domingo}
          />
          {
            domingo.value == 1 ?
              <>
                <Input
                  icon="MdTimer"
                  label="Hora de abertura aos domingos"
                  name="hora_abertura_domingo"
                  type="time"
                />
                <Input
                  icon="MdTimer"
                  label="Hora de encerramento aos domingos"
                  name="hora_encerramento_domingo"
                  type="time"
                />
              </> : <></>
          }
          <Select
            name="modelo_atendimento"
            labelSelect="Modelo de atendimento"
            options={modeloTemplate}
            onChange={e => setModelo(e)}
            defaultValue={modelo}
          />

          <Select
            name="temperatura"
            labelSelect="Irá trabalhar com sistema de temperatura"
            options={dataTemplate}
            onChange={e => setTemperaturaId(e)}
            defaultValue={temperaturaId}
          />

          <Select
            name="corretores"
            labelSelect="Irá trabalhar com sistema de corretores"
            options={dataTemplate}
            onChange={e => setCorretoresId(e)}
            defaultValue={corretoresId}
          />

          <Button tamanho="40px" load={carregar}>
            Editar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

TimesEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};
